import React from 'react';
import {useTranslation} from 'react-i18next';

import {CenterLayout, Section} from '@pexip/components';
import type {RouteMatch} from '@pexip/router';

import {BrandedFullSizeWindow} from '../viewModels/BrandedFullSizeWindow.viewModel';
import {NonMeetingHeader} from '../viewModels/NonMeetingHeader.viewModel';
import {TestId} from '../../test/testIds';
import {useBranding} from '../branding/Context';

export const PageNotFound: React.FC<{match: RouteMatch}> = () => {
    const {t} = useTranslation();
    const overlay = useBranding('overlay');

    return (
        <BrandedFullSizeWindow
            padding="none"
            background="dark"
            flexDirection="column"
            justifyContent="flexStart"
        >
            <NonMeetingHeader />
            <CenterLayout className="p-3">
                <Section
                    data-testid={TestId.NotFoundMessage}
                    title={t('error.not-found.title', 'Oops! 404 - Not Found')}
                    subtitle={t(
                        'error.not-found.subtitle',
                        "We can't seem to find the page you're looking for.",
                    )}
                    colorScheme={overlay}
                />
            </CenterLayout>
        </BrandedFullSizeWindow>
    );
};
